export const enum State {
  CONNECTED = 'CONNECTED',
  WORKING = 'WORKING',
  CONSULTING = 'CONSULTING',
  WAITING = 'WAITING',
  CREATING = 'CREATING',
  CHATTING = 'CHATTING',
  WORKING_CHAT = 'WORKING_CHAT',
  PAUSE_1 = 'PAUSE_1',
  PAUSE_2 = 'PAUSE_2',
  PAUSE_3 = 'PAUSE_3',
  PAUSE_4 = 'PAUSE_4',
  PAUSE_5 = 'PAUSE_5',
  PAUSE_6 = 'PAUSE_6',
  PAUSE_7 = 'PAUSE_7',
  PAUSE_8 = 'PAUSE_8',
  PAUSE_9 = 'PAUSE_9',
  DISCONNECTED = 'DISCONNECTED',
}

export const enum RoleType {
  AGENT = 'AGENT',
  SUP = 'SUP',
  ADMIN = 'ADMIN',
  EVAL = 'EVAL',
  CALIBRATOR = 'CALIBRATOR',
  AUTO_EVAL = 'AUTO_EVAL',
  TECHNICAL = 'TECHNICAL',
}

export const enum Profiles {
  BOT = 'BOT',
}

export type UserLandingPageDTOV1 = {
  landingPagePath: string
}

export interface UserParamsDTOV3 {
  'include-deactivated'?: boolean
  expand?: UserExpandEnum[]
  include?: UserIncludeEnum
}

export interface UserDTOV3 {
  lastName?: string
  firstName?: string
  login: string
  externalId?: string
  active: boolean
  teamCode: UUID
  phone?: string
  emailAddress?: string
  roles?: UserRole[]
  skills?: string[]
  trainedSkills?: string[]
  state?: State
}

export interface UserRole {
  code: string
  type: RoleType
  active: boolean
}

export enum UserIncludeEnum {
  STATE = 'STATE',
}

export enum UserExpandEnum {
  ROLES = 'ROLES',
  SKILLS = 'SKILLS',
}
